import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {HawalasListHeader} from './components/header/HawalasListHeader'
import {HawalasTable} from './table/HawalasTable'
import {HawalaEditModal} from './hawala-edit-modal/HawalaEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const HawalasList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <HawalasListHeader />
        <HawalasTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <HawalaEditModal />}
    </>
  )
}

const HawalasListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <HawalasList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {HawalasListWrapper}
